exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-border[data-v-2f5e2372] {\n  border: 1px solid !important;\n}\n.preview-email-template[data-v-2f5e2372] {\n  height: 210px;\n  width: 458px;\n  padding: 7px;\n  border: 1px solid #ccc;\n  overflow: auto;\n}\n", ""]);

// exports
